import React from 'react';
import {
  Nav,
  NavbarToggler,
  NavbarBrand,

} from 'reactstrap';
import HeaderDropdown from './HeaderDropdown';
import ChangePasswordModal from '../ChangePasswordModal';
import UpdateProfileModal from '../UpdateProfileModal';
import { toast } from 'react-toastify';

class Header extends React.Component {

  constructor(props) {
    super(props);
    this.changePasswordToggle = this.changePasswordToggle.bind(this);
    this.updateProfileToggle = this.updateProfileToggle.bind(this);

    this.updatePassword = this.updatePassword.bind(this);
    this.updateProfile = this.updateProfile.bind(this);

    this.state = {
      changePasswordVisible: false,
      updateProfileVisible: false
    };
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  changePasswordToggle() {
    this.setState({
      changePasswordVisible: !this.state.changePasswordVisible
    });
  }


  updateProfileToggle() {
    this.setState({
      updateProfileVisible: !this.state.updateProfileVisible
    });
  }

  updatePassword(formData) {
    const { dispatchPasswordUpdateSelf } = this.props;
    dispatchPasswordUpdateSelf(formData, (err) => {
      if (!err) {
        toast.success("Password updated successfully, once you logout, you will be required to use the new password");
        this.changePasswordToggle();
      }
    });
  }

  updateProfile(formData) {
    const { dispatchPasswordUpdateSelf } = this.props;
    dispatchPasswordUpdateSelf(formData, (err) => {
      if (!err) {
        toast.success("Profile updated Successfully");
        this.updateProfileToggle();
      }
    });
  }

  render() {
    const { logout, self, passwordUpdateSelfData } = this.props;
    const { changePasswordVisible, updateProfileVisible } = this.state;
    return (
      <header className="app-header navbar">
        <ChangePasswordModal
          passwordUpdateSelfData={passwordUpdateSelfData}
          onSubmit={this.updatePassword}
          isOpen={changePasswordVisible}
          toggle={this.changePasswordToggle}
        />

        <UpdateProfileModal
          passwordUpdateSelfData={passwordUpdateSelfData}
          onSubmit={this.updateProfile}
          isOpen={updateProfileVisible}
          toggle={this.updateProfileToggle}
        />

        <NavbarBrand href="#"></NavbarBrand>
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
          <i className="fa fa-bars fa-lg text-primary" aria-hidden="true"></i>
        </NavbarToggler>
        <NavbarToggler className="d-md-down-none mr-auto" onClick={this.sidebarToggle}>
          <i className="fa fa-bars fa-lg text-primary" aria-hidden="true"></i>
        </NavbarToggler>
        <Nav className="ml-auto" navbar>
          <HeaderDropdown notif />
          <HeaderDropdown
            changePassword={this.changePasswordToggle}
            updateProfile={this.updateProfileToggle}
            logout={logout} self={self}
            accnt
          />

        </Nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js